import { EmailContentDefinition } from 'modules/graphql/types';
import { TemplateEditViews } from '../../common/types';
import { useEditableFieldsContext } from '../../context/EditableFieldsContext';
import { usePreviewWithDataContext } from '../../context/PreviewWithDataContext';
import { useQueryParamContext } from '../../context/QueryParamContext';
import { useEmailPreviewContext } from '../context/EmailPreviewContext';
import {
  EmailHeaderAddress,
  EmailHeaderAddressFrom,
  EmailHeaderAddressTo,
  EmailHeaderContainer,
  EmailHeaderPreheader,
  EmailHeaderSubject,
} from './styles';

export const PreviewContentHeader = () => {
  const { liveTemplate } = useEditableFieldsContext();
  const { messageFromName, messagePreheader, messageSubject } = useEmailPreviewContext();
  const { isDataFeedDataEmpty, isUserDataEmpty } = usePreviewWithDataContext();
  const { view } = useQueryParamContext();

  const emailData = (liveTemplate?.mediumData ?? {}) as EmailContentDefinition;
  const usePopulatedField =
    view === TemplateEditViews.preview && (!isDataFeedDataEmpty || !isUserDataEmpty);

  const preheader = usePopulatedField ? messagePreheader : (emailData.preheaderText ?? '');
  const subject = usePopulatedField ? messageSubject : (emailData.subject ?? '');
  const fromName = usePopulatedField ? messageFromName : (emailData.fromName ?? '');

  return (
    <EmailHeaderContainer data-test="email-header">
      <EmailHeaderSubject data-test="email-subject">{subject}</EmailHeaderSubject>
      {!!emailData.preheaderText && (
        <EmailHeaderPreheader data-test="email-preheader">{preheader}</EmailHeaderPreheader>
      )}
      <EmailHeaderAddress>
        <EmailHeaderAddressFrom data-test="email-from-name">
          {`${fromName} <${emailData.fromEmail}>`}
        </EmailHeaderAddressFrom>
        <EmailHeaderAddressTo>to me</EmailHeaderAddressTo>
      </EmailHeaderAddress>
    </EmailHeaderContainer>
  );
};
